import React from 'react';
import { Dialog } from 'evergreen-ui';
import { format } from 'date-fns';
import { DATE_FORMATS } from 'Utils/formats';
import { Charts } from './Timeseries.Charts';

export const TimeseriesChartsContext = React.createContext(null);

const { Provider } = TimeseriesChartsContext;

export default function TimeseriesChartsProvider({ children, paginate }) {
  const [selectedColumnIndex, setSelectedColumnIndex] = React.useState(null);

  return (
    <Provider value={{ setSelectedColumnIndex }}>
      {children}
      {selectedColumnIndex !== null && (
        <Dialog
          isShown
          title={`График в период с ${format(new Date(paginate.startDate), DATE_FORMATS.timeseries.withoutSecondsTable)} по ${format(new Date(paginate.endDate), DATE_FORMATS.timeseries.withoutSecondsTable)}`}
          onCloseComplete={() => setSelectedColumnIndex(null)}
          hasFooter={false}
          width="75%"
          minHeightContent={600}
        >
          <Charts columnIndex={selectedColumnIndex} isDialog paginate={paginate} />
        </Dialog>
      )}
    </Provider>
  );
}
